import { ValidationRuleSchema } from 'vee-validate/dist/types/types'

const KANA =
  'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン'
const KANA_DAKUTEN = 'ガギグゲゴザジズゼゾダヂヅデドバビブベボヴ'
const KANA_HANDAKUTEN = 'パピプペポ'
const SPACE = ' 　'
const SYMBOL = '()\\.\\-/「」（）ー／'
const REGEX = `^[${KANA}${KANA_DAKUTEN}${KANA_HANDAKUTEN}${SYMBOL}${SPACE}0-9A-Z]*$`

const BankAccount: ValidationRuleSchema = {
  validate(value: string) {
    const regex = new RegExp(REGEX)
    return regex.test(value)
  },
}

export default BankAccount
